<template>
  <div>
    <div class="card">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">{{ $t('catalogue.popUpDispoReseau.gestion')}}</h1>
          </div>
        </div>
      </div>
      <br>
      <div class="card-content">
        <error-msg-component :messages="messages"
                             :error="error"
                             :title="'editionClient.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = $event"/>
        <div class="columns">
        <b-field :label="$t('catalogue.popUpDispoReseau.depart')"
                 class="column is-6">
          <b-select v-model="modificationSemaine.jourDeDepart" expanded>
            <option v-for="jour in listeJour"
                    :key="jour.number"
                    :value="jour.number">
              {{ ucFirst(jour.libelle)}}
            </option>
          </b-select>
        </b-field>
            <b-field :label="$t('catalogue.popUpDispoReseau.faceDispo')"
                     class="column is-6">
              <input-currency v-model="modificationSemaine.nbFacePrevues" isNumber="true">
              </input-currency>
            </b-field>
        </div>
        <div class="columns">
          <b-field :label="$t('catalogue.popUpDispoReseau.dateDebut')"
                   class="obligatoire column is-6">
            <b-datepicker show-week-number
              nearby-selectable-month-days
              icon="calendar-today" v-model="dateDebutDisplay"
              :editable="true">
            </b-datepicker>
          </b-field>
          <b-field :label="$t('catalogue.popUpDispoReseau.dateFin')"
                   class="column is-6">
            <b-datepicker show-week-number
              nearby-selectable-month-days
              icon="calendar-today"
              v-model="dateFinDisplay"
              :editable="true">
            </b-datepicker>
          </b-field>
        </div>
        <div class="columns">
          <b-field :label="$t('catalogue.popUpDispoReseau.objectif')"
                     class="column is-6">
              <input-currency v-model="modificationSemaine.objectif" isNumber="true">
              </input-currency>
            </b-field>
        </div>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close">
              {{ $t('catalogue.popUpDispoReseau.cancel') }}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="enregistrerDispo">
              {{ $t('general.button.sauvegarder') }}
            </a>
          </div>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import * as dateConf from '@/configuration/datePickerConf';
import ucFirst from '@/services/general/ucFirst';
import inputCurrency from '@/components/general/inputCurrency';
import validationProduit from '@/services/catalogue/validation/validationProduit';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import { addDisponibiliteReseau } from '@/api/dispo/index';
import formatDate from '@/services/general/formatIsoDate';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validationGeneral from '@/services/validation/validation';

export default {
  props: {
    infoSemaine: Object,
  },
  components: {
    inputCurrency,
    errorMsgComponent,
  },
  data() {
    return {
      messages: [],
      error: false,
      dateDebutDisplay: this.infoSemaine.dateDebut,
      dateFinDisplay: this.infoSemaine.dateFin,
      modificationSemaine: {
        jourDeDepart: this.infoSemaine.facePrevus === 0 ? null : this.infoSemaine.jourDeDepart,
        nbFacePrevues: this.infoSemaine.facePrevus === 0 ? null : this.infoSemaine.facePrevus,
        dateDebut: this.infoSemaine.dateDebut,
        dateFin: this.infoSemaine.dateFin,
        produitId: this.infoSemaine.produitId,
        objectif: this.infoSemaine.objectif,
      },
      listeJour: dateConf.LISTE_INDEX_JOURS,
      messagesChampsVide: [],
      champsVide: [],
    };
  },
  methods: {
    ucFirst(libelle) {
      return ucFirst(libelle);
    },
    async enregistrerDispo() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.modificationSemaine.dateDebut = formatDate(this.dateDebutDisplay);
        this.modificationSemaine.dateFin = formatDate(this.dateFinDisplay);
        if (!this.modificationSemaine.jourDeDepart) this.modificationSemaine.jourDeDepart = 0;
        if (!this.modificationSemaine.nbFacePrevues) this.modificationSemaine.nbFacePrevues = 0;
        await addDisponibiliteReseau(this.modificationSemaine);
        messageSucces(this.$t('catalogue.popUpDispoReseau.dispoAdd'));
        loadingComponent.close();
        this.$parent.close();
        this.$emit('reloadDispoReseau');
      } catch (e) {
        this.modificationSemaine.jourDeDepart = null;
        if (e.response.data.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = validationProduit(e.response);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, null);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
};
</script>
